
export type MarkLectureAsCompleted200 = {
  message?: string;
  success?: boolean;
};
